import {IWithSummaryModel} from '../../../../../common/permission/api/entity/iWithSummary.model';
import {PaymentRequestSummaryModel} from './paymentRequestSummary.model';
import {SaleSummaryModel} from '../../../../api/entity/saleSummary.model';
import {PaymentRequestReminderSummaryModel} from "../../reminder/api/entity/paymentRequestReminderSummary.model";

export class PaymentRequestModel implements IWithSummaryModel<PaymentRequestSummaryModel> {
    summary: PaymentRequestSummaryModel;
    sale: SaleSummaryModel;
    reminders: PaymentRequestReminderSummaryModel[];
    groupedChildren: PaymentRequestSummaryModel[];
}

export enum PAYMENT_REQUEST_STATUS {
    PAYMENT_REQUEST_STATUS_PAID = 'PAYMENT_REQUEST_STATUS_PAID',
    PAYMENT_REQUEST_STATUS_CREATED = 'PAYMENT_REQUEST_STATUS_CREATED',
    PAYMENT_REQUEST_STATUS_SENT = 'PAYMENT_REQUEST_STATUS_SENT',
    PAYMENT_REQUEST_STATUS_WILL_NOT_PAY = 'PAYMENT_REQUEST_STATUS_WILL_NOT_PAY'
}
